import { cls, cn } from '@/utils';
import { memo } from 'react';

interface IBorderedLayoutProps {
	children?: React.ReactNode;
	containerClassName?: string;
	horizontal?: boolean;
}

const BorderedLayout = ({
	children,
	containerClassName,
	horizontal = false,
}: IBorderedLayoutProps) => {
	return (
		<div
			className={cn(
				cls('border h-fit last:border-l-0', containerClassName),
				horizontal && 'flex w-full last:border-r-0'
			)}
		>
			{children}
		</div>
	);
};

export default memo(BorderedLayout);
